const EQUALWEB_SHADOW_HOST_SELECTORS = ['#INDShadowRootHost', '#INDshadowRootWrap'];

const HIDE_EW_MENU_BTN =
  '#INDmenu-btn{position:fixed!important;left:-10000px!important;top:0!important;width:1px!important;height:1px!important;opacity:0!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;clip-path:inset(50%)!important;white-space:nowrap!important;border:0!important;padding:0!important;margin:0!important;}';

const EW_OFFSCREEN_STYLE_ID = 'equalweb-launch-offscreen';

const MENU_BTN_SELECTOR = '#INDmenu-btn';

function findEqualWebButtonDeepFrom(root: Document | ShadowRoot): HTMLElement | null {
  const direct = root.querySelector<HTMLElement>(MENU_BTN_SELECTOR);
  if (direct) return direct;
  const tree = root.querySelectorAll<HTMLElement>('*');
  for (let i = 0; i < tree.length; i += 1) {
    const node = tree[i] as HTMLElement & { shadowRoot?: ShadowRoot | null };
    if (node.shadowRoot) {
      const found = findEqualWebButtonDeepFrom(node.shadowRoot);
      if (found) return found;
    }
  }
  return null;
}

function findEqualWebButton(): HTMLElement | null {
  const direct = document.getElementById('INDmenu-btn') as HTMLElement | null;
  if (direct) return direct;

  const inKnownHosts = EQUALWEB_SHADOW_HOST_SELECTORS.reduce<HTMLElement | null>(
    (found, selector) => {
      if (found) return found;
      const host = document.querySelector(selector) as
        | (HTMLElement & { shadowRoot?: ShadowRoot })
        | null;
      return host?.shadowRoot?.querySelector<HTMLElement>(MENU_BTN_SELECTOR) ?? null;
    },
    null,
  );
  if (inKnownHosts) return inKnownHosts;

  return findEqualWebButtonDeepFrom(document);
}

export function installEqualWebLaunchButtonOffscreenStyle(): void {
  if (typeof document === 'undefined') return;

  if (!document.getElementById(EW_OFFSCREEN_STYLE_ID)) {
    const inDoc = document.createElement('style');
    inDoc.id = EW_OFFSCREEN_STYLE_ID;
    inDoc.textContent = HIDE_EW_MENU_BTN;
    document.head.appendChild(inDoc);
  }

  EQUALWEB_SHADOW_HOST_SELECTORS.forEach(selector => {
    const host = document.querySelector(selector) as
      | (HTMLElement & { shadowRoot?: ShadowRoot })
      | null;
    const { shadowRoot } = host || {};
    if (shadowRoot && !shadowRoot.getElementById(EW_OFFSCREEN_STYLE_ID)) {
      const s = document.createElement('style');
      s.id = EW_OFFSCREEN_STYLE_ID;
      s.textContent = HIDE_EW_MENU_BTN;
      shadowRoot.appendChild(s);
    }
  });
}

type InterdealRuntime = {
  isPending?: boolean;
  a11y?: { openMenu?: (e?: Event) => void; a11yBtn?: HTMLElement | null };
};

function getInterdeal(): InterdealRuntime | undefined {
  if (typeof window === 'undefined') return undefined;
  return (window as { interdeal?: InterdealRuntime }).interdeal;
}

const RETRY_DELAYS_MS = [50, 100, 200, 400, 800, 1600, 3200, 5000];

export const showEqualWebDrawer = (): void => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;

  let done = false;

  const run = (): void => {
    if (done) return;
    installEqualWebLaunchButtonOffscreenStyle();
    const interdeal = getInterdeal();
    const a11y = interdeal?.a11y;
    if (a11y?.openMenu && a11y.a11yBtn) {
      if (interdeal?.isPending) {
        return;
      }
      try {
        a11y.openMenu();
        done = true;
        return;
      } catch {} // eslint-disable-line no-empty
    }
    const button = findEqualWebButton();
    if (button) {
      button.click();
      done = true;
    }
  };

  const scheduleRetries = (): void => {
    RETRY_DELAYS_MS.forEach(ms => {
      window.setTimeout(() => {
        if (!done) run();
      }, ms);
    });
  };

  run();
  if (done) return;

  const onAccLoaded = () => {
    if (!done) run();
  };
  document.addEventListener('INDAccLoaded', onAccLoaded, { once: true, capture: true });

  scheduleRetries();
};
